import "./Footer.css";

const Footer = ({ lang, isContactPage, isMobile }) => {
    const containerStyle = {
        height: isContactPage ? '100vh' : 'auto',
    }

    const loadingMotionStyle = {
        display: isContactPage ? (window.innerWidth <= 800 ? 'block' : 'none') : 'block'
    }
    const bottomStyle = {
        position: isContactPage ? 'fixed' : 'absolute',
        top: isContactPage ? 'initial' : '0px',
        bottom: isContactPage ? '0px' : 'initial'
    }

    const gradientStyle = {
        display: isContactPage ? 'none' : 'block'
    }

    const contactMobileStyle = {
        position: isContactPage ? 'absolute' : 'relative',
        bottom: isContactPage ? '0px' : ''
    }

    return (
        <div className="overlay-footer-container"
            style={containerStyle}>
            <div className="overlay-footer-pc">
                <div className="overlay-footer-loading-motion"
                    style={loadingMotionStyle}>
                    <video
                        autoPlay
                        playsInline
                        muted
                        preload="auto"
                        loop
                    >
                        <source
                            src={process.env.PUBLIC_URL + "/data/loading/footer_motion.mov"}
                            type='video/mp4' />
                        <source
                            src={process.env.PUBLIC_URL + "/data/loading/footer_motion.webm"}
                            type='video/webm' />
                    </video>
                </div>
                <div className="overlay-footer-gradient-cover"
                    style={gradientStyle}></div>
                <div className="overlay-footer-gradient-top"
                    style={gradientStyle}></div>
                <div className="overlay-footer-bottom-container"
                    style={bottomStyle}>
                    <div className="overlay-footer-bottom">
                        <div className="overlay-footer-address">
                            <a href="https://naver.me/xKQolpLy" target="_blank" rel="noopener noreferrer" title="Open Map">
                                {lang === 'ENG'
                                    ? <>10F, Halla Eco Valley, 25, Ttukseom-ro 1-gil<br />
                                        Seongdong-gu, Seoul 04778, Korea</>
                                    : <>대한민국 서울특별시 성동구<br />
                                        뚝섬로 1길 25, 한라에코벨리 10층 (04778)</>
                                }
                            </a>
                        </div>
                        <div className="overlay-footer-email">
                            <a href="mailto:hello@h9works.com" title="Email to hello@h9works.com">hello@h9works.com</a>
                        </div>
                        <div className="overlay-footer-phone">
                            <div>Tel<br />Fax</div>
                            <div className="overlay-footer-phone-number">02-521-0518<br />02-567-0518</div>
                        </div>
                    </div>
                    <div className="overlay-footer-bottom-right">
                        <div className="overlay-footer-link-container">
                            <a href="https://hnine.com" target="_blank" rel="noopener noreferrer">
                                <button>HNINE</button></a>
                            <a href="https://flashy-kettle-285.notion.site/Interaction-Tech-Blog-11f95fbcdd57803686bde5a475448231" target="_blank" rel="noopener noreferrer">
                                <button>Tech Blog</button></a>
                        </div>
                        <div className="overlay-footer-copyright">
                            © 2025 HNINE Co., Ltd. All rights reserved.
                        </div>
                    </div>
                </div>
            </div>

            <div className="overlay-footer-mobile" style={contactMobileStyle}>
                <div className="overlay-footer-loading-motion"
                    style={loadingMotionStyle}>
                    <video
                        autoPlay
                        playsInline
                        muted
                        preload="auto"
                        loop
                    >
                        <source
                            src={process.env.PUBLIC_URL + "/data/loading/footer_motion.mov"}
                            type='video/mp4' />
                        <source
                            src={process.env.PUBLIC_URL + "/data/loading/footer_motion.webm"}
                            type='video/webm' />
                    </video>
                </div>
                <div className="overlay-footer-gradient-cover"></div>
                <div className="overlay-footer-gradient-top"></div>
                <div className="overlay-footer-bottom">
                    <div className="overlay-footer-bottom-textcontainer">
                        <div className="overlay-footer-address">
                            <a href="https://naver.me/xKQolpLy" target="_blank" rel="noopener noreferrer" title="Open Map">
                                {lang === 'ENG'
                                    ? <>10F, Halla Eco Valley, 25, Ttukseom-ro 1-gil<br />
                                        Seongdong-gu, Seoul 04778, Korea</>
                                    : <>대한민국 서울특별시 성동구<br />
                                        뚝섬로 1길 25, 한라에코벨리 10층 (04778)</>
                                }
                            </a>
                        </div>
                        <div className="overlay-footer-email">
                            <a href="mailto:hello@h9works.com" title="Email to hello@h9works.com">hello@h9works.com</a>
                        </div>
                        <div className="overlay-footer-phone">
                            <div>Tel<br />Fax</div>
                            <div className="overlay-footer-phone-number">02-521-0518<br />02-567-0518</div>
                        </div>
                    </div>
                    <div className="overlay-footer-link-container">
                        <a href="https://hnine.com" target="_blank" rel="noopener noreferrer">
                            <button>HNINE</button></a>
                        <a href="https://flashy-kettle-285.notion.site/Interaction-Tech-Blog-11f95fbcdd57803686bde5a475448231" target="_blank" rel="noopener noreferrer">
                            <button>Tech Blog</button></a>
                    </div>
                </div>
                <div className="overlay-footer-copyright">
                    © 2025 HNINE CO. LTD. All rights reserved.
                </div>
            </div>

        </div>


    );
};

export default Footer